// extracted by mini-css-extract-plugin
export default {"response":"ApiResponse_response__5t8dM","appertoground":"ApiResponse_appertoground__6lWHb","close":"ApiResponse_close__IjD-n"};